import { useEffect, useMemo, useState } from 'react';
import { LocalStorageKeys } from '$constants';
import { getLocalStorage, setLocalStorage } from '$services/local-storage';
import { useStores } from '~/store';
import { IStoreInformation, StockType } from '$models';
import { getStockType } from '$lib/helpers';

type Props = {
    productStock: Record<string, number> | undefined;
};

export const useProductStock = ({ productStock }: Props) => {
    const { getStores, stores, isLoading } = useStores();
    const [selectedStore, setSelectedStore] = useState<IStoreInformation>();
    const [selectedStoreStockType, setSelectedStoreStockType] = useState<StockType>();

    useEffect(() => {
        getStores();
    }, []);

    useEffect(() => {
        const getSelectedStore = async () => {
            const storeId = await getLocalStorage<string>(LocalStorageKeys.SelectedStoreId);
            if (storeId) {
                setSelectedStore(stores?.find((store) => store.customerId === storeId));
                setSelectedStoreStockType(getStockType(productStock?.[storeId] || undefined));
            }
        };

        if (stores) {
            getSelectedStore();
        }
    }, [stores, productStock]);

    const stockCount = useMemo(() => {
        if (!productStock) {
            return 0;
        }
        let count = 0;
        Object.keys(productStock).forEach((key) => {
            const value = productStock[key];
            if (value) {
                count++;
            }
        });
        return count;
    }, [productStock]);

    const onStoreSelection = (id?: string) => {
        if (id) {
            setLocalStorage(LocalStorageKeys.SelectedStoreId, id);
            setSelectedStore(stores?.find((store) => store.customerId === id));
            setSelectedStoreStockType(getStockType(productStock?.[id] || undefined));
        }
    };

    return {
        stockCount,
        selectedStore,
        selectedStoreStockType,
        isLoading,
        onStoreSelection,
    };
};
